import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import DeleteTwoToneIcon from "@material-ui/icons/DeleteTwoTone";
import CreateIcon from "@material-ui/icons/Create";
import { WarningModal } from "../../../common/WarningModal";
import ModalQuiz from "./ModalQuiz";
import { deleteQuiz } from "../../../backend/EditCourseDetails";
import { deleteToast, errorToast } from "../../../common/Toastify";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  status: {
    color: theme.palette.info.main,
  },
  invoice: {
    color: theme.palette.error.main,
  },
  container: {
    maxHeight: 600,
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: "#ffff",
    },
  },

  arrowIcon: {
    width: "30px",
    height: "30px",
  },
}));

function Row({ quiz }) {
  const classes = useStyles();
  const [modalQuiz, setModalQuiz] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const { id } = useParams();

  async function handleConfirmDelete() {
    const res = await deleteQuiz(quiz?.id, id);
    if (res.successfull) {
      setOpenWarningModal(false);
      deleteToast("Quiz");
    } else {
      errorToast();
    }
  }

  return (
    <React.Fragment>
      <WarningModal
        open={openWarningModal}
        setOpen={setOpenWarningModal}
        message={"Assignment"}
        subMessage={"All Data will be deleted & wont be accessible anymore"}
        deleteItem={handleConfirmDelete}
      />
      <ModalQuiz setModal={setModalQuiz} modal={modalQuiz} editQuiz={quiz} />
      <TableRow className={classes.root}>
        <TableCell>
          <img
            src="https://s3-alpha-sig.figma.com/img/2ca5/3cee/9ffafad2556184843786ebd14b3bede1?Expires=1682294400&Signature=WlqxGXEdM~miuOFcengUcbCVP5eSsRfCjkTO38PGPBHjAKSnGwO10nWKoHFA3eDEhg6cmEac57Jtg-6b7-Kao7A3m-zAhrA5t5yjcYPILIrIhd6AhjFHKaeEK2nQ2Enp5LD0Ew8FudA2butrgO5ZBnAAdEXILhOPYILtqEkncpNKCWGjyppFjJdUKnb0CRVfL2N~-LYANOnqLMwDkTCoELi-H7kn0d16Nd3v3Ou59xX9yhjscoE7vjh0Aad4ro0XGySNaXp5zZRj-DcYEGY4KRxe3YWVLpN2YIjdrJC5bwURfGF7NSyz9VfZZ5S0YqEoLvMKByMugiWcephUqKlfBA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4"
            alt=""
            width={45}
            height={45}
          />
        </TableCell>
        <TableCell>{quiz?.title}</TableCell>
        <TableCell style={{ width: 300 }}>{quiz?.description}</TableCell>
        <TableCell>{quiz?.duration}</TableCell>
        <TableCell>{quiz?.createdAt}</TableCell>
        <TableCell>
          <IconButton
            aria-label="delete"
            id={quiz?.docId}
            style={{ color: "#00000052", padding: 0 }}
            onClick={() => setOpenWarningModal(true)}
          >
            <DeleteTwoToneIcon />
          </IconButton>

          <IconButton
            aria-label="delete"
            id={quiz?.docId}
            style={{ color: "#00000052", padding: 0, marginLeft: 20 }}
            onClick={() => setModalQuiz(true)}
          >
            <CreateIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const QuizTable = ({ quizData, searchVal }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, quizData?.length - page * rowsPerPage);

  return (
    <>
      <TableContainer className={classes.container} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Title</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Time Duration</TableCell>
              <TableCell>Date of Publish</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          {quizData?.length ? (
            <TableBody>
              {quizData
                ?.filter((item) =>
                  searchVal === null || searchVal === ""
                    ? item
                    : item?.title
                        ?.toLowerCase()
                        .includes(searchVal.toLowerCase())
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return <Row key={index} quiz={item} />;
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableCell>
                <p>Please Add a Order</p>
              </TableCell>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={quizData?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default QuizTable;
